/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ActorActivityRecordActorUserId } from './ActorActivityRecordActorUserId';
import {
    ActorActivityRecordActorUserIdFromJSON,
    ActorActivityRecordActorUserIdFromJSONTyped,
    ActorActivityRecordActorUserIdToJSON,
    ActorActivityRecordActorUserIdToJSONTyped,
} from './ActorActivityRecordActorUserId';
import type { SearchQueryRequest } from './SearchQueryRequest';
import {
    SearchQueryRequestFromJSON,
    SearchQueryRequestFromJSONTyped,
    SearchQueryRequestToJSON,
    SearchQueryRequestToJSONTyped,
} from './SearchQueryRequest';

/**
 * 
 * @export
 * @interface AppointmentScrollQuery
 */
export interface AppointmentScrollQuery {
    /**
     * 
     * @type {ActorActivityRecordActorUserId}
     * @memberof AppointmentScrollQuery
     */
    locationId: ActorActivityRecordActorUserId | null;
    /**
     * 
     * @type {ActorActivityRecordActorUserId}
     * @memberof AppointmentScrollQuery
     */
    teacherId: ActorActivityRecordActorUserId | null;
    /**
     * 
     * @type {boolean}
     * @memberof AppointmentScrollQuery
     */
    includeOnlyOnline: boolean | null;
    /**
     * 
     * @type {any}
     * @memberof AppointmentScrollQuery
     */
    date: any | null;
    /**
     * 
     * @type {SearchQueryRequest}
     * @memberof AppointmentScrollQuery
     */
    searchQuery: SearchQueryRequest | null;
}

/**
 * Check if a given object implements the AppointmentScrollQuery interface.
 */
export function instanceOfAppointmentScrollQuery(value: object): value is AppointmentScrollQuery {
    if (!('locationId' in value) || value['locationId'] === undefined) return false;
    if (!('teacherId' in value) || value['teacherId'] === undefined) return false;
    if (!('includeOnlyOnline' in value) || value['includeOnlyOnline'] === undefined) return false;
    if (!('date' in value) || value['date'] === undefined) return false;
    if (!('searchQuery' in value) || value['searchQuery'] === undefined) return false;
    return true;
}

export function AppointmentScrollQueryFromJSON(json: any): AppointmentScrollQuery {
    return AppointmentScrollQueryFromJSONTyped(json, false);
}

export function AppointmentScrollQueryFromJSONTyped(json: any, ignoreDiscriminator: boolean): AppointmentScrollQuery {
    if (json == null) {
        return json;
    }
    return {
        
        'locationId': ActorActivityRecordActorUserIdFromJSON(json['locationId']),
        'teacherId': ActorActivityRecordActorUserIdFromJSON(json['teacherId']),
        'includeOnlyOnline': json['includeOnlyOnline'],
        'date': json['date'],
        'searchQuery': SearchQueryRequestFromJSON(json['searchQuery']),
    };
}

export function AppointmentScrollQueryToJSON(json: any): AppointmentScrollQuery {
    return AppointmentScrollQueryToJSONTyped(json, false);
}

export function AppointmentScrollQueryToJSONTyped(value?: AppointmentScrollQuery | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'locationId': ActorActivityRecordActorUserIdToJSON(value['locationId']),
        'teacherId': ActorActivityRecordActorUserIdToJSON(value['teacherId']),
        'includeOnlyOnline': value['includeOnlyOnline'],
        'date': value['date'],
        'searchQuery': SearchQueryRequestToJSON(value['searchQuery']),
    };
}

